<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Activity Logs
          </div>
          <div class="card-block">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th>Author</th>
                  <th>Controller</th>
                  <th>Action</th>
                  <th>Date</th>
                  <th>JSON</th>
                </tr>
              </thead>
              <tbody>
                <loading-rows v-if="loading" cols='5'/>
                <tr v-for="activity in activityLogs" v-if="!loading">
                  <td><v-gravatar v-bind:email="activity.author" class="img-avatar" v-bind:alt="activity.author" :size="16"/> {{activity.author}}</td>
                  <td>{{activity.controller}}</td>
                  <td><activity-icon v-bind:activity="activity"/> {{activity.action}}</td>
                  <td>{{activity.created_at | moment('from')}}</td>
                  <td><button class="btn btn-primary" @click="viewJSON(activity)">View JSON</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <pagination v-bind:totalEntries="pagination.total_entries" v-bind:totalPages="pagination.total_pages" v-bind:currentPage="pagination.current_page"></pagination>
      </div>
    </div>
  </div>

</template>

<script>

import ActivityLogs from 'services/activityLogs'
import ActivityIcon from 'components/ActivityIcon'
import Pagination from 'components/Pagination'
import LoadingRows from 'components/LoadingRows'
import {EventBus} from 'services/eventBus'

export default {
  name: 'activity-logs',
  created () {
    this.fetchData()
  },
  data () {
    return {
      activityLogs: [],
      loading: false,
      pagination: {},
      order: 'created_at desc'
    }
  },
  computed: {
    page () {
      if (this.$route.query.page) {
        return this.$route.query.page
      }
      return 1
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  components: {
    Pagination,
    LoadingRows,
    ActivityIcon
  },
  methods: {
    fetchData () {
      ActivityLogs.all(this)
    },
    viewJSON (activity) {
      EventBus.$emit('json-modal', {
        title: 'Activity Log JSON',
        content: JSON.stringify(activity, null, 2)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/ActivityLogs.vue